import async from 'components/template/Async';

export const CONFIRM_SELLER_INFO_PATH = '/marketplace/confirm-seller-info';

export const ConfirmSellerInfo = async(() => import('pages/marketplace/ConfirmSellerInfo'));
